import { getSDK as getUnlinkSDK } from '../sdk/UnlinkInstance';
import { loadLocalKeys } from "../db/KeyStorageManager";
import { Keypair } from '@solana/web3.js';
import WebSocketService from "./WebSocketService";

export async function startUserSession({ password, userId, salt }) {
  const unlinkSdk = getUnlinkSDK();

  const keys = await loadLocalKeys({userId, password, salt});

  // for 64 bytes total secret
  const secretKey = new Uint8Array(64);
  secretKey.set(keys.fundingPrivateKey, 0);
  secretKey.set(keys.fundingPublicKey, 32);

  const fundingWallet = Keypair.fromSecretKey(secretKey);
  unlinkSdk.setPayer({payer: fundingWallet});

  // start message stream, preload user data
  await WebSocketService.init({userId, password, salt});

  return true;
}